import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrinterService } from '../../../core/services/printer.service';

@Component({
  selector: 'app-bill-print-format-modal',
  templateUrl: './bill-print-format-modal.component.html',
  styleUrls: ['./bill-print-format-modal.component.scss']
})
export class BillPrintFormatModalComponent {
  @Input() visible = false;
  @Input() invoiceType: string | null | undefined = 'invoice';
  @Input() isDownloading = false;
  @Output() closed = new EventEmitter<void>();
  @Output() printFormat = new EventEmitter<string>();
  @Output() pdfDownload = new EventEmitter<'a4' | 'a5'>();

  constructor(private printerService: PrinterService) {}

  get thermalEnabled(): boolean {
    return this.printerService.isThermalEnabled();
  }

  get a4Enabled(): boolean {
    return this.printerService.isA4Enabled();
  }

  get a5Enabled(): boolean {
    return this.printerService.isA5Enabled();
  }

  get hasPrintOptions(): boolean {
    return this.thermalEnabled || this.a4Enabled || this.a5Enabled;
  }

  get isGstBill(): boolean {
    return this.invoiceType === 'invoice' || !this.invoiceType;
  }

  get isEstimate(): boolean {
    return this.invoiceType === 'estimate';
  }

  onClose(): void {
    this.closed.emit();
  }

  onPrint(format: string): void {
    this.printFormat.emit(format);
  }

  onPdf(size: 'a4' | 'a5'): void {
    this.pdfDownload.emit(size);
  }
}
